<form [formGroup]="formGroup" class="needs-validation" #detailViewFormRef>
  <form-builder
    *ngIf="relatedFormModel?.selectedFeature !== undefined"
    [graphicFormGroup]="formGroup"
    [viewExpanded]="viewExpanded"
    [detailFormDataModel]="relatedFormModel"
    [formattedFormFields]="formattedFormFields"
  >
  </form-builder>
</form>
